import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';
import lodash from 'lodash';
// Constant
import Colors from '../../constants/Colors';

export class ImageWithPlaceholder extends Component {
  static propTypes = {
    src: PropTypes.string,
  };

  state = {
    error: false,
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!lodash.isEqual(this.props.src, prevProps.src)) {
      this.setState({ error: false });
    }
  }

  render() {
    const { src, size, customClass } = this.props;
    if (this.state.error || !src) {
      return (
        <SvgIcon viewBox='0 0 60 60' style={{ fontSize: size }}>
          <path
            fill={Colors.SECONDARY_FONT_COLOR}
            d='M18.35 17.903a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414 2.61 2.61 0 0 1 0-3.684 4.575 4.575 0 0 0 1.35-3.256 4.57 4.57 0 0 0-1.35-3.256.999.999 0 1 0-1.414 1.414c.492.492.764 1.146.764 1.842 0 .696-.271 1.35-.764 1.842a4.61 4.61 0 0 0 0 6.512zm22 0a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414 2.61 2.61 0 0 1 0-3.684 4.575 4.575 0 0 0 1.35-3.256 4.57 4.57 0 0 0-1.35-3.256.999.999 0 1 0-1.414 1.414c.492.492.764 1.146.764 1.842 0 .696-.271 1.35-.764 1.842a4.61 4.61 0 0 0 0 6.512zm-11-6a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414 2.61 2.61 0 0 1 0-3.684 4.575 4.575 0 0 0 1.35-3.256 4.57 4.57 0 0 0-1.35-3.256.999.999 0 1 0-1.414 1.414c.492.492.764 1.146.764 1.842 0 .696-.271 1.35-.764 1.842a4.61 4.61 0 0 0 0 6.512zM55.624 40.82c-1.812-10.64-10.107-19.096-20.667-21.144.017-.16.043-.32.043-.48 0-2.757-2.243-5-5-5s-5 2.243-5 5c0 .16.025.32.043.48C14.483 21.723 6.188 30.178 4.376 40.82 2.286 42.002 0 43.743 0 45.696c0 5.085 15.512 8.5 30 8.5s30-3.415 30-8.5c0-1.953-2.286-3.694-4.376-4.877zM27.006 19.37A3.004 3.004 0 0 1 30 16.196a3.004 3.004 0 0 1 2.994 3.171c-.047-.005-.094-.007-.14-.012a25.32 25.32 0 0 0-1.038-.089c-.128-.009-.255-.022-.383-.029a26.126 26.126 0 0 0-1.432-.04c-.481 0-.958.014-1.432.04-.128.007-.255.02-.383.03-.348.023-.694.051-1.038.088-.048.005-.095.006-.142.012zm-1.661 6.34c.073 0 .147-.009.221-.025a20.141 20.141 0 0 1 4.421-.488H30a1 1 0 1 0 0-2h-.014a22.17 22.17 0 0 0-4.86.537 1 1 0 0 0 .219 1.975zM9.821 42.178a1 1 0 0 0 1.163-.803c1.039-5.698 4.473-10.768 9.186-13.56a1 1 0 0 0-1.019-1.72c-5.204 3.082-8.992 8.66-10.134 14.92a.998.998 0 0 0 .804 1.163zm16.578-20.713a24.358 24.358 0 0 1 1.952-.207 24.54 24.54 0 0 1 3.632.025c.542.044 1.082.102 1.619.182 10.418 1.575 18.657 9.872 20.152 20.316.046.321.083.643.116.965.011.111.026.221.036.332.039.443.068.886.082 1.33a106.717 106.717 0 0 1-47.974 0c.015-.444.043-.887.082-1.33.01-.11.024-.22.036-.332.033-.323.07-.645.116-.965 1.494-10.444 9.733-18.742 20.151-20.316zM30 52.196c-17.096 0-28-4.269-28-6.5 0-.383.474-1.227 2.064-2.328-.004.057-.002.113-.006.17-.034.548-.058 1.1-.058 1.658v.788l.767.185A108.293 108.293 0 0 0 30 49.141c8.489 0 16.979-.99 25.233-2.972l.767-.185v-.788c0-.558-.024-1.109-.058-1.658-.004-.057-.002-.113-.006-.17C57.526 44.47 58 45.313 58 45.696c0 2.231-10.904 6.5-28 6.5z'
          />
        </SvgIcon>
      );
    } else {
      return (
        <img
          src={src}
          onError={() => this.setState({ error: true })}
          alt=''
          className={customClass}
        />
      );
    }
  }
}
